export default __webpack_public_path__ + "356300ad2865d27eae785eee6c6ee918.svg";